<!--content-->
<div class="request">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumbs">
          <ul>
            <li>
              <a routerLink="/dashboard">
                Inicio
              </a>
            </li>
            <li>
              <a routerLink="/license/renew">
                Solicitar
              </a>
            </li>
            <li>
              <a routerLink="/license/renew">
                Renovar licencia
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12">
        <h2 class="txt txt--title">
          {{variant === 'personal' ? 'Renovar mi licencia' : 'Renovar licencia para un empleado o contratista'}}</h2>
        <small>A través del siguiente formulario podrás renovar los requisitos asociados a tu licencia.</small>
      </div>
      <div class="request__content col-12">
        <div class="mb-4" *ngIf="variant === 'third'">
          <app-person-card [personData]="person || {}" [boxColor]="personBoxColor"></app-person-card>
          <span class="back back--small u-mt10 global-hand" (click)="goBack()">
            Buscar otro conductor
          </span>
        </div>
        <div class="border-b pb-3">
          <app-license-card *ngIf="license && licenseZones && person" [usingAspect]="'EXTEND_LICENSE'"
            [licensesData]="license" [zonesRows]="licenseZones" [userData]="person" [selectedOption]="selectedOption">
          </app-license-card>
        </div>

        <app-documents-load
          *ngIf="equipmentDataToSend && this.licenseRequirementId && this.person"
          [documentFormArray]="documentFormArray"
          [requirementId]="this.requirementId"
          [licenseRequirementId]="this.licenseRequirementId"
          [equipmentDataToSend]="equipmentDataToSend"
          [assetId]="assetId"
          [driverMdmId]="this.person.mdmid"
          [canReuseOldDocuments]="canReuseOldDocs"
          numberSection="1"
          requestType="RENEW"
          [driverIsEmployee]="selectedPersonIsEmployee"
        >
        </app-documents-load>

        <div class="textWarningFillDocumentContainer">
          <p class="textWarningFillDocument">
            {{ this.documentFormArray.errors ? this.documentFormArray.errors.description : ' '}}
            &nbsp;
          </p>
        </div>

        <div class="border-b"></div>

        <div *ngIf="!selectedPersonIsEmployee" [ngClass]="{'u-lock': !documentFormArray.valid }">
          <app-form-contract-owner-selector
            [enabled]="documentFormArray.valid "
            [numberSection]="2"
            (personSelected)="onSetContractOwner($event)"
          >
          </app-form-contract-owner-selector>
        </div>
        <div class="border-b"></div>

        <app-form-employee
          *ngIf="selectedPersonIsEmployee"
          [isEmployee]="true"
          [assetId]="license?.asset?.id"
          [enabled]="this.selectedPersonIsEmployee ? documentFormArray.valid : this.contractFormControl.valid"
          [controlForm]="employeeFormControl"
          [numberSection]="this.selectedPersonIsEmployee ? '2' : '3'"
        >
        </app-form-employee>
        <div class="border-b"></div>

        <div class="mt-4" [ngClass]="{'u-lock': !shouldEnableSubmit }">
          <div class="form">
            <div class="form__check">
              <input type="checkbox" name="checkbox" value="agree-terms" id="agree-terms" [formControl]="agreeTerms">
              <label for="agree-terms">
                <div class="fakebox fakebox--grey"></div>
                <span>&nbsp;</span>
              </label>
              <span class="spanTerm-aconditions ">
                Confirmo que he leído los <a (click)="showModalConfirmTermsAndConditions()"
                  class="no-padding hover-hand" data-modal="modal01">términos y
                  condiciones</a> y doy fe de la veracidad de los documentos ingresados para evitar sanciones
                asociadas.
              </span>
            </div>
          </div>
          <div class="buttons u-mt20">
            <div class="row">
              <div class="col-md-3 order-md-1 order-2">
                <a class="btn btn--link" (click)="showCancelModal()">Cancelar solicitud</a>
              </div>
              <div class="col-md-9 order-md-2 order-1">
                <button type="button" class="btn btn--primary modal__trigger" (click)="showConfirmationModal()"
                  [attr.disabled]="!(documentFormArray.valid && agreeTerms.value) ? true : null">Enviar
                  formulario
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!--content-->
